export const version = "1.0.2-daily-20260422-0";
export const channel = "daily";
export const gitcommit = "807b8e2dc";
